module.exports = __webpack_public_path__ + "static/cmac-thumb-2acbbfb9229c5ddb1d0f962d0ff07a3a.jpg";